import React, {useRef} from 'react';
import HeroSection from '../components/Home/HeroSection';
import Solutions from '../components/Home/Solutions';
import Features from '../components/Home/Features';
import IndustryIcons from '../components/Home/IndustryIcons';
import Team from '../components/Home/Team';
import Testimonials from '../components/Home/Testimonials';
import CTASection from '../components/Home/CTASection';

const Home = ({onFeaturesRef}) => {
  const featuresRef = useRef(null);
  const solutionsRef = useRef(null);

  // Pass the ref up to Navbar via a callback prop
  React.useEffect(() => {
    if (onFeaturesRef) {
      onFeaturesRef(featuresRef);
    }
  }, [onFeaturesRef]);

  // Handle scroll to Solutions
  const scrollToSolutions = () => {
    if (solutionsRef.current) {
      solutionsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen">
      <HeroSection onExploreSolutions={scrollToSolutions} />
      <div className="py-4 md:py-8 lg:py-16" ref={solutionsRef}>
        <Solutions />
      </div>
      <div className="py-4 md:py-8 lg:py-16">
        <Features />
      </div>
      <div className="py-4 md:py-8 lg:py-16">
        <IndustryIcons />
      </div>
      <div className="py-4 md:py-8 lg:py-16">
        <Testimonials />
      </div>
      <div className="py-4 md:py-8 lg:py-16">
        <Team />
      </div>
      
      <div className="pt-4 md:pt-8 lg:pt-16">
        <CTASection />
      </div>
    </div>
  );
};

export default Home;
